export const MuiPalette = {
    primary: {
        main: '#003C60',
    },
    secondary: { main: '#007373', dark: '#006363' },
    error: {
        main: '#FF545A',
    },
     text: {
        primary: '#000',
        secondary: '#003C60',
    }, 
};
